import { render, staticRenderFns } from "./OtherStaffCreditTable.vue?vue&type=template&id=6c81ee46&scoped=true"
import script from "./OtherStaffCreditTable.vue?vue&type=script&lang=js"
export * from "./OtherStaffCreditTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c81ee46",
  null
  
)

export default component.exports